import { useState, useEffect } from 'react';
import { MenuService } from '@src/api/web-services/layout/MenuService';
import {
  MenuModel,
  MenuRequest,
} from '@src/api/web-services/layout/MenuService/MenuTypes';
import { useAuthSessionStore } from '@src/store/common/AuthSessionStore';

export const useMenu = (request: MenuRequest = { skipRoles: false }) => {
  const [menuItems, setMenuItems] = useState<MenuModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const sessionEpoch = useAuthSessionStore((state) => state.sessionEpoch);

  const { GetMenu } = MenuService();

  const fetchMenuItems = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await GetMenu(request);

      if (response.hasError) {
        setError(response.message || 'Failed to load menu items');
        setMenuItems([]);
      } else {
        // Sort menu items by sequenceOrder and filter active items
        const sortedItems = response.results
          .filter((item) => item.isActive)
          .sort((a, b) => a.sequenceOrder - b.sequenceOrder);

        setMenuItems(sortedItems);
      }
    } catch (err) {
      setError('Failed to load menu items');
      setMenuItems([]);
      console.error('Menu fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenuItems();
  }, [sessionEpoch]);

  return {
    menuItems,
    loading,
    error,
    refetch: fetchMenuItems,
  };
};
